import { render, staticRenderFns } from "./BusCaptains.vue?vue&type=template&id=555647fe&scoped=true&"
import script from "./BusCaptains.vue?vue&type=script&lang=js&"
export * from "./BusCaptains.vue?vue&type=script&lang=js&"
import style0 from "./BusCaptains.vue?vue&type=style&index=0&id=555647fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555647fe",
  null
  
)

export default component.exports